import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import accountApi from "../../api/accountApi";
import taskApi from "../../api/taskApi";
import usersApi from "../../api/usersApi";
import { Button } from "../../components/Button";
import FormField from "../../components/ui/FormField";
import { toast } from "react-toastify";
import { Plus, Trash2, X } from "lucide-react";
import { Spinner } from "reactstrap";
import { uploadToCloudinary } from "../../utils/cloudinaryUpload";
import TaskDocumentsViewer from "../../components/Upload/TaskDocumentsViewer";
import TaskUploadManager from "../../components/Upload/TaskUploadManager";
import { FaPaperclip, FaUpload } from "react-icons/fa";
import uploadApi from "../../api/uploadApi";
import { formatDateTime } from "../../utils/dateFormatter";
import { compressFile } from "../../utils/imageCompression";
import { confirmSubmit } from "../../utils/confirmSubmit";
// import AttachmentUploader from "../../components/ui/Attachments";

const AddTasks = ({
  accontdId,
  taskId,
  onClose,
  onRefreshAccounts,
  setShowCreateTask,
  attachments,
  setAttachments,
  comments,
  setComments,
  formData,
  setFormData,
}) => {
  const token = useSelector((state) => state.auth.access_token);
  const user = useSelector((state) => state.auth.userdetails.fullName);
  const currentUserId = useSelector((state) => state.auth.userdetails.id);
  const [isLoader, setIsLoader] = useState(false);
  const [isAccountLocked, setIsAccountLocked] = useState(false);

  // const [formData, setFormData] = useState({
  //   title: "",
  //   description: "",
  //   dueDate: new Date().toISOString().split("T")[0],,
  //   startDate: new Date().toISOString().split("T")[0],
  //   priority: "LOW",
  //   status: "TODO",
  //   assignedTo: "",
  //   account: "",
  // });

  const [accounts, setAccounts] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoader2, setIsLoader2] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleUploadSuccess = () => {
    setShowUpload(false);
    setRefreshKey((prev) => prev + 1);
  };
  const handleFieldChange = (name) => (val) =>
    setFormData((prev) => ({ ...prev, [name]: val }));

  useEffect(() => {
    accountApi.getAllAccounts(token, 0, 30).then((res) => {
      const accList = res?.data?.content || [];
      setAccounts(accList);

      if (!taskId && accontdId) {
        setFormData((prev) => ({
          ...prev,
          account: accontdId,
        }));
        setIsAccountLocked(true);
      }
    });

    usersApi.getAllUsers(token).then((res) => {
      setUsers(res?.data || []);
    });
  }, [token, accontdId]);

  const refreshTaskData = async () => {
    if (!taskId) return;
    try {
      const res = await taskApi.updateTask(taskId, {}, token);
      const t = res.data;

      setFormData({
        title: t.title || "",
        description: t.description || "",
        dueDate: t.dueDate?.split("T")[0] || "",
        startDate: t.startDate?.split("T")[0],
        priority: t.priority || "LOW",
        status: t.status || "TODO",
        assignedTo: t.assignedTo?.id || "",
        account: t.account?.id || "",
      });

      setAttachments(t.attachments || []);
      setComments(t.comments || []);
    } catch (err) {
      console.error("Failed to refresh task data", err);
    }
  };

const handleFileUpload = async (e) => {
  const files = Array.from(e.target.files);
  if (!files.length) return;

  for (const originalFile of files) {
    setIsLoader2(true);

    try {
      const compressedFile = await compressFile(originalFile);

      if (compressedFile.size > 1 * 1024 * 1024) {
        toast.error(
          `${compressedFile.name} is too large. Max allowed size is 1MB.`
        );
        setIsLoader2(false);
        continue;
      }

      const fd = new FormData();
      fd.append("file", compressedFile);

      const cloudinaryRes = await uploadApi.uploadTask(
        taskId,
        "attachments",
        fd,
        token
      );

      const payload = {
        fileName: compressedFile.name,
        filePath: cloudinaryRes.fileUrl,
        contentType: compressedFile.type,
      };

      setAttachments((prev) => [...prev, payload]);

      if (taskId) {
        await taskApi.addAttachment(taskId, payload, token);
        toast.success("Attachment uploaded successfully");
        onRefreshAccounts();
      }
    } catch (err) {
      toast.error(`Failed to upload ${originalFile.name}`);
    } finally {
      setIsLoader2(false);
    }
  }

  e.target.value = "";
};


  const handleAdd = () => {
    setComments([...comments, { content: "" }]);
  };

  const handleChange = (index, value) => {
    const updated = [...comments];
    updated[index].content = value;
    setComments(updated);
  };

  const handleRemove = async(index) => {
    const isConfirmed = await confirmSubmit({
              title: "Confirm task delete",
              text: "Are you sure you want to delete this task?",
              confirmText: "Submit",
            });
          if (!isConfirmed) return;

    if (!isConfirmed) return;
    const updated = comments.filter((_, i) => i !== index);
    setComments(updated);
  };

  const handleRemoveAttachment = async (index, attachment) => {
    const isConfirmed = window.confirm("Are you sure you want to continue?");

    if (!isConfirmed) return;
    try {
      if (attachment?.id) {
        await taskApi.deleteAttachment(attachment.id, token);
        toast.success("Attachment deleted successfully");
        onRefreshAccounts();
      }

      setAttachments((prev) => prev.filter((_, i) => i !== index));
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete attachment");
    }
  };

  const [errors, setErrors] = useState({});
  const safeTrim = (value) => (value || "").trim();

  const validateForm = () => {
    const newErrors = {};

    if (!safeTrim(formData.title)) newErrors.title = "Title is required";

    if (!safeTrim(formData.assignedTo))
      newErrors.assignedTo = "Assigned To is required";

    if (!formData.status) newErrors.status = "Status is required";
    if (!formData.priority) newErrors.priority = "Priority is required";
    if (!formData.startDate) newErrors.startDate = "Start Date is required";
    if (!formData.dueDate) newErrors.dueDate = "Due Date is required";
    if (!formData.description)
      newErrors.description = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (saveAndNew = false) => {
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      setIsLoader(false);
      return;
    }

    const now = new Date().toISOString();
    setIsLoader(true);
    const formattedComments = comments.filter((c) => c?.content?.trim() !== "");
    const payload = {
      ...formData,
      assignedToId: formData.assignedTo,
      account: { id: formData.account },
      createdBy: { id: currentUserId, fullName: user },
      updatedBy: { id: currentUserId, fullName: user },
      updatedAt: now,
      attachments: attachments,
      comments: formattedComments,
    };

    try {
      setIsLoader(true);
      if (taskId) {
        await taskApi.updateTask(taskId, payload, token);
        toast.success("Tasks updated Successfully");
        onRefreshAccounts?.();
        setIsLoader(false);
        onClose();
      } else {
        await taskApi.createTask(formData.account, payload, token);
        toast.success("Tasks Created Successfully");
        onRefreshAccounts?.();
        setIsLoader(false);
        onClose();
      }

      if (saveAndNew) {
        setIsLoader(false);
        setFormData({
          title: "",
          description: "",
          dueDate: "",
          startDate: new Date().toISOString().split("T")[0],
          priority: "LOW",
          status: "TODO",
          assignedTo: "",
          account: "",
        });
        setAttachments([]);
        setComments([{ content: "" }]);
      }
    } catch (err) {
      setIsLoader(false);
      console.error("Save failed", err);
    }
  };

  const clearTask = () => {
    setFormData({
      title: "",
      description: "",
      dueDate: "",
      startDate: new Date().toISOString().split("T")[0],
      priority: "LOW",
      status: "TODO",
      assignedTo: "",
      account: "",
    });
    setAttachments([]);
    setComments([{ content: "" }]);
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="bg-white max-h-[93vh] rounded-lg shadow-xl max-w-3xl w-full p-3 overflow-y-auto"
    >
      <div className="flex flex-row items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-800">
          {taskId ? "Edit Task" : "Create Task"}
        </h1>
        <button
          onClick={() => {
            setShowCreateTask(false);
            clearTask();
          }}
          aria-label="Close"
          type="button"
          className="p-1 rounded-md bg-red-50 hover:bg-red-100 text-red-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          <X size={20} />
        </button>
      </div>

      <div>
        <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-2">
          <FormField
            label="Title"
            type="string"
            required
            maxLength={100}
            value={formData.title}
            onChange={handleFieldChange("title")}
            error={errors.title}
          />

          <FormField
            label="Assigned To"
            type="dropdown"
            required
            value={formData.assignedTo}
            onChange={handleFieldChange("assignedTo")}
            options={users.map((u) => ({
              label: u.fullName,
              value: u.id,
            }))}
            error={errors.assignedTo}
          />
          {/* {!isEditMode && (
            <FormField
              label="Account"
              type="dropdown"
              required
              value={formData.account}
              onChange={handleFieldChange("account")}
              disabled={isAccountLocked}
              options={accounts.map((a) => ({
                label: a.accountName,
                value: a.id,
              }))}
            />
          )} */}
          {taskId ? (
            <FormField
              label="Status"
              type="dropdown"
              required
              value={formData.status}
              onChange={handleFieldChange("status")}
              options={[
                "TODO",
                "IN_PROGRESS",
                "COMPLETED",
                "CLOSED",
                "PENDING",
                "IN_REVIEW",
                "PROPOSED",
                "OVERDUE",
              ]}
              error={errors.status}
            />
          ) : (
            <></>
          )}

          <FormField
            label="Priority"
            type="dropdown"
            value={formData.priority}
            onChange={handleFieldChange("priority")}
            options={["LOW", "MEDIUM", "HIGH"]}
            error={errors.priority}
          />

          <FormField
            label="Start Date"
            type="date"
            required
            min={new Date().toISOString().split("T")[0]}
            value={formData.startDate}
            onChange={handleFieldChange("startDate")}
            error={errors.startDate}
          />

          <FormField
            label="Due Date"
            type="date"
            required
            min={formData.startDate}
            value={formData.dueDate}
            onChange={handleFieldChange("dueDate")}
            error={errors.dueDate}
          />
        </div>

        <div className="mt-1">
          <FormField
            label="Description"
            type="description"
            rows="2"
            required
            value={formData.description}
            onChange={handleFieldChange("description")}
            error={errors.description}
          />
        </div>
      </div>
      <div className="border border-gray-200 rounded-lg p-2 mt-1">
        <div className="flex justify-between items-center mb-1">
          <div className="text-sm font-semibold text-gray-700">Attachments</div>

          <label className="flex items-center gap-1 cursor-pointer text-xs text-indigo-600 hover:text-indigo-800">
            <FaUpload size={12} />
            {isLoader2 ? <Spinner size={"sm"} /> : <span>Upload</span>}
            <input
              type="file"
              multiple
              className="hidden"
              onChange={handleFileUpload}
            />
          </label>
        </div>

        {attachments?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {attachments.map((f, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-2 border border-gray-100 rounded-md bg-white hover:bg-gray-100 transition"
              >
                <div className="flex flex-col min-w-0">
                  <div className="flex items-center gap-2">
                    <FaPaperclip className="text-gray-400 text-xs shrink-0" />
                    <a
                      href={f.filePath}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-gray-700 truncate hover:underline"
                      title={f.fileName}
                    >
                      {f.fileName}
                    </a>
                  </div>

                  <span className="text-[10px] text-gray-400 ml-5">
                    {formatDateTime(f.uploadedAt)}
                  </span>
                </div>

                <button
                  onClick={() => handleRemoveAttachment(index, f)}
                  className="text-xs text-red-500 hover:text-red-700 shrink-0"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-gray-400">No attachments uploaded</p>
        )}
      </div>
      <div className="w-full space-y-3 my-2 p-2 border border-gray-200 rounded-lg">
        <div className="text-sm font-semibold mb-1">Comments</div>
        {comments.map((item, index) => (
          <div key={index} className="flex gap-2 w-full">
            <input
              type="text"
              value={item.content}
              onChange={(e) => handleChange(index, e.target.value)}
              placeholder={`Comment ${index + 1}`}
              className="border rounded px-3 py-1 w-full"
            />

            {comments.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="text-red-500"
              >
                <Trash2 size={14} />
              </button>
            )}
            {index === comments.length - 1 && (
              <button
                type="button"
                onClick={handleAdd}
                className="bg-primary text-white px-2 rounded-full"
              >
                <Plus size={18} />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="flex flex-row items-center justify-end gap-2">
        {/* <Button className="mr-4" label="Cancel" onClick={() => navigate("/tasks")} /> */}
        {/* {!isEditMode && (
                      
                      <Button
                          label="Save and New"
                          className="mr-4"
                          onClick={() => handleSubmit(true)}
                      />
                  )} */}
        <button
          type="button"
          onClick={() => {
            setShowCreateTask(false);
            clearTask();
          }}
          className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
        >
          Cancel
        </button>
        {isLoader ? (
          <Button label={<Spinner size={"sm"} />} />
        ) : (
          <Button
            label={taskId ? "Update" : "Save"}
            onClick={() => handleSubmit(false)}
          />
        )}
      </div>
      <TaskUploadManager
        taskId={taskId}
        isOpen={showUpload}
        onClose={() => setShowUpload(false)}
        onUploadSuccess={handleUploadSuccess}
      />
      {/* {isEditMode && (
        <TaskAttachments
          taskId={taskId}
          attachments={attachments}
          onRefresh={refreshTaskData}
        />
      )}

      {isEditMode && (
        <TaskComments
          taskId={taskId}
          comments={comments}
          onRefresh={refreshTaskData}
        />
      )} */}
    </div>
  );
};

export default AddTasks;
